module.exports = __webpack_public_path__ + "static/media/serviceAvatar.08d25684.png";